import React from 'react'
import PropTypes from 'prop-types'
import {
  Step,
  StepFooter,
  Button,
} from 'common/components/entities/TwoStepPaymentForm'
import ChildrenEntities from '../../core/ChildrenEntities'

function OptInStep({ entity, buttonStyles, mobileButtonStyles }) {
  return (
    <Step>
      <ChildrenEntities
        id={entity.id}
        type={entity.type}
        childIds={entity.childIds}
      />
      <Button
        styles={buttonStyles}
        mobileStyles={mobileButtonStyles}
        text={entity.options.buttonText}
        subText={entity.options.buttonSubText}
      />
      {entity.options.footerText && (
        <StepFooter>{entity.options.footerText}</StepFooter>
      )}
    </Step>
  )
}

export default OptInStep

OptInStep.propTypes = {
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    options: PropTypes.shape({
      buttonText: PropTypes.string.isRequired,
      buttonSubText: PropTypes.string.isRequired,
      footerText: PropTypes.string,
    }).isRequired,
    childIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  buttonStyles: PropTypes.shape({
    backgroundColor: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
  mobileButtonStyles: PropTypes.shape({
    backgroundColor: PropTypes.string,
    color: PropTypes.string,
  }),
}
